module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('label', {
    staticClass: "weui-cell weui-check__label",
    attrs: {
      "for": _vm.forItem,
      "checked": _vm.checked
    }
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._t("default")], true)]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('input', {
    staticClass: "weui-check",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "id": _vm.forItem,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "click": _vm.onItemClick
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "weui-icon-checked"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-6ac98514!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/radio.vue
// module id = 260
// module chunks = 0